export default __webpack_public_path__ + "static/mvp-b4df65c9d67dec622c82b5adec202a70.jpg";